import { initialState } from 'src/contexts/settings/settings-context';
import { patientDateOfServiceConstant } from '../../actions/constant';

const { GET_PATIENT_DATE_OF_SERVICE_SUCCESS, GET_PATIENT_DATE_OF_SERVICE_FAILURE } =
  patientDateOfServiceConstant;

const intitialstate: object = {
  isError: false,
  errorMessage: '',
  response: null,
};

export const getDateOfServiceReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_PATIENT_DATE_OF_SERVICE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isError: false,
        errorMessage: '',
      };
    }

    case GET_PATIENT_DATE_OF_SERVICE_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
      };

    default:
      return state;
  }
};
